import { Button, Form, Input, Modal, Select, Space, Typography } from 'antd'
import { gql, useLazyQuery, useMutation, useQuery } from '@apollo/client'
import { useContext, useEffect, useState } from 'react'

import AppContext from '../common/AppContext'
import { CURRENT_YEAR } from '../../util/commonUtil'
import { LOGIN } from '../../gql/auth.gql'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import axios from '../../axios/axios'
import useUserDirectory from '../../hooks/api/useUserDirectory'

const { Paragraph, Title } = Typography

const LoginAs = ({ visible, onSuccess, onClose }) => {
  const [loginError, setLoginError] = useState(false)
  const [loading, setLoading] = useState(false)
  const { currentUser } = useContext(AppContext)
  let { users, loading: usersLoading } = useUserDirectory(currentUser)

  useEffect(() => {
    if (visible) {
      setLoginError(false)
    }
  }, [visible])

  const doLoginAs = async (form) => {
    try {
      let { id } = form?.user
      id = _.trim(id)
      setLoading(true)
      const result = await axios.post('/auth/login-as', { id })
      onSuccess(result.data)
    } catch (e) {
      setLoginError(true)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal title="Login as other user" visible={visible} onCancel={onClose} footer={null} destroyOnClose>
      <Form onFinish={doLoginAs} layout="vertical">
        <Form.Item
          shouldUpdate
          name={[`user`, 'id']}
          label={
            <Title level={3} className="noPad">
              Username
            </Title>
          }
        >
          <Select
            placeholder="Select username (type to search)"
            notFoundContent="Not found"
            allowClear
            showSearch
            loading={loading}
            options={_.map(users, (u) => ({
              label: `${_.trim(u.lastName)}, ${_.trim(u.firstName)}`,
              value: u.id,
            }))}
            optionFilterProp="label"
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
            }
          />
        </Form.Item>

        <Space direction="vertical">
          {loginError && <Paragraph type="danger">An error occurred while logging in.</Paragraph>}
          <Space direction="horizontal">
            <Form.Item>
              <Button htmlType="submit" type="primary" loading={loading} disabled={loading}>
                Login as user
              </Button>
            </Form.Item>
          </Space>
        </Space>
      </Form>
    </Modal>
  )
}

export default LoginAs
